function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 32 28",
  fill: "none"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.85 27.738l-2.387-15.703L0 3.56 31.903 0 15.85 27.738zM14.68 9.885L7.287 5.23 24.81 3.275l-10.13 6.61zM15.96 12l1.277 8.408 8.595-14.85L15.958 12zm11.33-8.96l.025-.044-.05.005.025.04z",
  fill: "#354147"
})));